import { Redirect, Route, RouteComponentProps, RouteProps } from "react-router";
import { PageLoader } from "@remo-co/ui-core/src/components/PageLoader";
import useAuth from "../hooks/useAuth";

interface IAuthorizedRouteProps {
  authURL?: string;
}
const PrivateRoute = (props: IAuthorizedRouteProps & RouteProps) => {
  const { authURL, component: Component, location, ...rest } = props;
  const { isLoading, isAuthenticated } = useAuth();
  const render = (componentProps: RouteComponentProps) => {
    if (!Component) return null;

    if (isAuthenticated) {
      return <Component {...componentProps} />;
    }
    const path = location?.pathname;
    const search = location?.search;
    const url = `${authURL}?redirectTo=${path}${encodeURIComponent(
      search ?? "",
    )}`;

    return <Redirect to={url} />;
  };

  return (
    <>
      {isLoading && <PageLoader message="Authenticating" />}
      {!isLoading && <Route location={location} render={render} {...rest} />}
    </>
  );
};

export default PrivateRoute;
